export function containsOnlyValidCharacters(strings: Array<string | undefined | null>): boolean {
  return strings
    .map((string) => typeof string === "string" && !/&|<|>|"|'|`|=/.test(string))
    .every(Boolean);
}
